// extracted by mini-css-extract-plugin
export var carrotIconClass = "whats-new-module--carrot-icon-class--EBv91";
export var childrenContainer = "whats-new-module--children-container--6KdG4";
export var closed = "whats-new-module--closed--3Qfyy";
export var componentSpacing = "whats-new-module--component-spacing--FegsB";
export var newText = "whats-new-module--new-text--1cxZo";
export var numberOfNewItems = "whats-new-module--number-of-new-items--m6Ksi";
export var open = "whats-new-module--open--LFfLU";
export var stateOfHidingText = "whats-new-module--state-of-hiding-text--YFouE";
export var whatsNewBar = "whats-new-module--whats-new-bar--nDYuT";